import {
  HEX_18232F,
  HEX_1D2939,
  HEX_212F41,
  HEX_335880,
  HEX_477FBA,
  HEX_646A7E,
  HEX_ADB5C7,
  HEX_E2E8F0,
  HEX_ECF4FF,
  HEX_F2F6FA,
  HEX_FFFCEE,
} from '@tanium/colors';
import {
  Background2,
  Border2,
  defineColor,
  Foreground2,
  Primary3,
  Text3,
} from '@tanium/react-theme-definition';

export const HeaderFill = defineColor([HEX_ECF4FF, HEX_18232F]);
export const HeaderText = defineColor([HEX_646A7E, HEX_ADB5C7]);
export const HeaderBorder = Border2;
export const HeaderDisclosure = defineColor([HEX_646A7E, HEX_477FBA]);

export const ContainerBorder = Border2;
export const ContainerShadow = Primary3;

export const SortIcon = Foreground2;

export const DisclosureBox = Foreground2;

export const EmptyStateFill = defineColor([HEX_F2F6FA, HEX_212F41]);

export const RowEmphasisFill = defineColor([HEX_E2E8F0, HEX_18232F]);
export const RowSelectedFill = defineColor([HEX_ECF4FF, HEX_335880]);
export const RowExpandedFill = defineColor([HEX_F2F6FA, HEX_18232F]);
export const RowHoverFill = defineColor([HEX_FFFCEE, HEX_1D2939]);
export const RowFill = Background2;

export const SubtitleText = Text3;
